import React from 'react';
import classNames from 'classnames';

import { Typo } from 'uikit/content';

import styles from '../styles/videoContentBox.module.scss';

const VideoContentBox = ({
  title,
  children,
  className,
  label,
  shouldWrap,
}) => (
  <div className={classNames(styles.container, className)}>
    <div className={styles.title}>
      <Typo weight="medium" variant="s03">{title}</Typo>
      {label}
    </div>
    <div className={classNames(styles.itemContainer, shouldWrap && styles.shouldWrap)}>
      {children}
    </div>
  </div>
);

export default React.memo(VideoContentBox);
